export const searchFetchLocations = async (url, longitude, latitude, radius) => {
  const response = await fetch(url, {
    method: "POST",
    body: new URLSearchParams({
      longitude,
      latitude,
      radius
    })
  });
  return response.status === 404 ? void 0 : response.json();
};
